import React, { useMemo } from 'react';
import createPostingPreview from '../../views/nominal/NominalPostingPreviewForm';
import createPostedTransactions from '../../views/nominal/PostedTransactionsForm';
import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from 'utils/BackgroundJobs';
import PurchaseCreditPostMutation from 'graphql/mutations/supplier/PurchaseCreditPostMutation.graphql';
import PurchaseCreditPostingPreview from 'graphql/entities/supplier/PurchaseCreditPostingPreview';
import PurchaseCreditTransactions from 'graphql/entities/supplier/PurchaseCreditTransactions';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';

export const formActionsForPermissions = [
  { description: 'Preview Postings' },
  { description: 'View Transactions' },
  { description: 'Post Credit' },
];

const PURCHASE_CREDIT_POSTING_PREVIEW = createPostingPreview(PurchaseCreditPostingPreview);
const PURCHASE_CREDIT_VIEW_TRANSACTIONS = createPostedTransactions(PurchaseCreditTransactions);

export const usePurchaseCreditActions = () => {
  return [
    {
      description: 'Preview Postings',
      triggerModal: {
        modalContent: PURCHASE_CREDIT_POSTING_PREVIEW,
        entityId: 'id',
        pageView: true,
        modalProps: {
          formEntityCustomUrl: 'nominal/Postings/supplier/PurchaseCredit',
          forceReadOnly: true,
        },
      },
      performSave: true,
      saveMessage: 'Nominal/VAT Postings Preview',
      btnClass: 'btnInfo',
      individualButton: false,
      condition: displayPreview,
    },
    {
      description: 'View Transactions',
      triggerModal: {
        modalContent: PURCHASE_CREDIT_VIEW_TRANSACTIONS,
        entityId: 'id',
        pageView: true,
        modalProps: {
          formEntityCustomUrl: 'nominal/Transactions/supplier/PurchaseCredit',
          forceReadOnly: true,
        },
      },
      btnClass: 'btnInfo',
      individualButton: false,
      condition: displayTransactions,
    },
    {
      description: 'Post Credit',
      component: PostSelectButton,
      performSave: true,
      fn: postCredit,
      individualButton: true,
      saveMessage: 'Credit Posted',
      condition: canBePosted,
    },
  ];
};

function displayPreview(credit) {
  if (credit && credit.documentStatus) {
    return credit.documentStatus === 'DRAFT' || credit.documentStatus === 'RELEASED';
  }
  return false;
}

function displayTransactions(credit) {
  if (credit && credit.documentStatus) {
    return credit.documentStatus === 'POSTED' || credit.documentStatus === 'CREDITED';
  }
  return false;
}

function canBePosted(credit) {
  if (credit && credit.documentStatus) {
    return credit.documentStatus === 'DRAFT' || credit.documentStatus === 'RELEASED';
  }
  return false;
}

function postCredit(props) {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(PurchaseCreditPostMutation, input, props, 'back', 'Post Credit');
}
